import { StyleSheet, Dimensions, Platform } from 'react-native';

const { width, height } = Dimensions.get('window');

export default StyleSheet.create({
  contentMinimal: {
    flexGrow: 1,
    backgroundColor: '#f5f5f5',
    paddingHorizontal: 24,
    paddingTop: 48,
    alignItems: 'center',
  },

  title: {
    fontSize: 24,
    fontWeight: '700',
    textAlign: 'center',
    color: '#1F2024',
    marginBottom: 24,
  },

  container: {
    width: '100%',
    maxWidth: 600,
    alignItems: 'flex-start',
    backgroundColor: '#f5f5f5',
    padding: 24,
    borderRadius: 16,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 2,
  },

  row: {
    width: '100%',
    marginBottom: 20,
  },

  areaRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 20,
    gap: 12,
  },

  areaColumn: {
    flex: 1,
  },

  subLabel: {
    fontSize: 15,
    color: '#1F2024',
    fontWeight: '500',
    lineHeight: 22,
  },

  checkboxLabel: {
    fontSize: 15,
    lineHeight: 22,
    color: '#1F2024',
    textAlign: 'justify',
  },

  divider: {
    height: 1,
    backgroundColor: '#E0E0E0',
    width: '100%',
    marginVertical: 24,
  },

  optionButtonsContainer: {
    width: '100%',
    marginTop: 8,
  },

  optionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderColor: '#E0E0E0',
    borderWidth: 1,
    borderRadius: 10,
    paddingVertical: 14,
    paddingHorizontal: 18,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 3,
    elevation: 1,
  },

  optionIcon: {
    width: 24,
    height: 24,
    marginRight: 12,
  },

  optionTextContainer: {
    flex: 1,
  },

  optionTextTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2024',
  },

  optionTextSubtitle: {
    fontSize: 12,
    color: '#7A7A7A',
  },

  buttonContainer: {
    marginTop: 32,
    alignItems: 'center',
  },

  laterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 25,
    borderWidth: 1,
    borderColor: '#730d83',
    backgroundColor: '#f5f5f5',
  },

  laterIcon: {
    width: 20,
    height: 20,
    marginRight: 8,
    tintColor: '#730d83',
  },

  laterButtonText: {
    color: '#730d83',
    fontSize: 15,
    fontWeight: '600',
  },

  cardStatus: (status) => ({
    fontWeight: 'bold',
    color:
      status === 'concluida'
        ? '#2E7D32'
        : status === 'em_progresso'
          ? '#F9A825'
          : '#C62828',
  }),

  buttonsRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
    marginTop: 32,
  },

  outlinedButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: '#730d83',
    backgroundColor: '#f5f5f5',
  },

  outlinedIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
    tintColor: '#730d83',
  },

  outlinedText: {
    color: '#730d83',
    fontSize: 15,
    fontWeight: '600',
  },


});
